export function extractApiMessage(data: unknown): string | null {
	if (typeof data === 'string' && data.trim()) {
		return data.trim()
	}

	if (!data || typeof data !== 'object') {
		return null
	}

	const record = data as Record<string, unknown>
	const message = record.message

	if (typeof message === 'string' && message.trim()) {
		return message.trim()
	}

	if (Array.isArray(message)) {
		const joined = message.map(String).filter(Boolean).join('. ')
		return joined || null
	}

	const responseData = record.data

	if (typeof responseData === 'string' && responseData.trim()) {
		return responseData.trim()
	}

	return null
}

export function extractApiErrorMessage(error: unknown): string | null {
	if (typeof error === 'string' && error.trim()) {
		return error.trim()
	}

	if (!error || typeof error !== 'object') {
		return null
	}

	const message = (error as Record<string, unknown>).error

	if (typeof message === 'string' && message.trim()) {
		return message.trim()
	}

	if (Array.isArray(message)) {
		const joined = message.map(String).filter(Boolean).join('. ')
		return joined || null
	}

	return null
}
